import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { SectionHead, Btn, Reveal, Quote, CountUp, SolutionTile, Photo } from "../components/ui.js";
import { SceneArt, DashboardArt } from "../components/illustrations.js";
import { SOLUTIONS } from "../data/innovation.js";

/* ============================================================
   LEVELUP ONE — Innovation (layout อ้างอิงเว็บต้นแบบ)
   hero → AI workforce → stats → featured bento → all solutions → cta
   ============================================================ */

export default class Innovation extends Component {
  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
  }

  render() {
    const featured = SOLUTIONS.filter((s) => s.featured);

    const workforce = [
      { art: "dash", title: "LevelUp Manager — แชตเดียว สั่งงานทั้งทีม", desc: "สั่งงานทีม AI ผ่านแชตเดียว ครอบคลุมบัญชี คลัง ขาย และบริการลูกค้า" },
      { art: "chat", title: "เชื่อมบนระบบเดิม", desc: "ต่อกับ POS, LINE, Excel และระบบที่ใช้อยู่ โดยไม่ต้องรื้อของเดิม" },
      { art: "retail", title: "ทำงานตลอดทุกช่องทาง", desc: "ขายหน้าร้านและออนไลน์ ซิงก์ข้อมูลตรงกันทุกที่แบบเรียลไทม์" },
      { art: "team", title: "ทำเป็นทีม ไม่ใช่แค่บอตเดียว", desc: "หลายบทบาททำงานพร้อมกัน เหมือนมีพนักงานครบทุกแผนก" },
    ];

    const review = {
      text: "ตั้งแต่ใช้โซลูชันของ LevelUp One งานหลังบ้านที่เคยวุ่นวายกลายเป็นระบบที่ดูแลตัวเองได้ ทีมเรามีเวลาโฟกัสกับลูกค้ามากขึ้นจริง ๆ",
      name: "ทีม LevelUp", role: "Customer Success", avatar: "💜",
    };

    return (
      <div className="nx">
        <Navbar />

        {/* ===== HERO ===== */}
        <section className="nx-inno-hero">
          <span className="nx-orb nx-orb--a" aria-hidden="true" />
          <span className="nx-orb nx-orb--b" aria-hidden="true" />
          <div className="container" style={{ position: "relative", zIndex: 1 }}>
            <Reveal>
              <span className="nx-eyebrow">INNOVATION · SOLUTIONS</span>
              <h1 className="nx-inno-hero__title mt-3">
                <span className="nx-gradient-text">Transform</span><br />your business.
              </h1>
              <p className="nx-inno-hero__lead">
                เราช่วยธุรกิจไทยเปลี่ยนผ่านสู่ดิจิทัลด้วยโซลูชันที่ทำงานได้จริง ทั้งระบบ ERP,
                POS ไปจนถึง Mobile App และ Web Application
              </p>
              <div className="nx-inno-hero__stats">
                <div className="nx-inno-hero__stat"><div className="n"><CountUp end={47} suffix="+" /></div><div className="l">โปรเจกต์ส่งมอบ</div></div>
                <div className="nx-inno-hero__stat"><div className="n"><CountUp end={62} suffix="+" /></div><div className="l">ลูกค้าองค์กร</div></div>
                <div className="nx-inno-hero__stat"><div className="n"><CountUp end={98.7} decimals={1} suffix="%" /></div><div className="l">ความพึงพอใจ</div></div>
              </div>
              <a href="#all-solutions" className="nx-btn nx-btn--primary">สำรวจโซลูชันของเรา</a>
            </Reveal>
          </div>
        </section>

        {/* ===== AI WORKFORCE ===== */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal>
              <SectionHead
                eyebrow="AI WORKFORCE"
                title="AI Workforce ทำงานครบวงจร · จากแชตเดียวสั่งงาน"
                subtitle="บัญชี คลัง ขาย บริการลูกค้า — ทำงานได้บนระบบเดิมทั้ง POS, LINE, Excel ผ่าน LevelUp Manager ตัวเดียว"
              />
            </Reveal>
            <div className="row g-4 mt-2">
              {workforce.map((w, i) => (
                <div className="col-12 col-md-6" key={w.title}>
                  <Reveal delay={i * 60}>
                    <div className="nx-card">
                      <div className="nx-browser mb-3">
                        <div className="nx-browser__bar">
                          <i style={{ background: "#f87171" }} /><i style={{ background: "#fbbf24" }} /><i style={{ background: "#34d399" }} />
                          <span className="nx-browser__url" />
                        </div>
                        <div className="nx-browser__body" style={{ padding: 14 }}>
                          {w.art === "dash" ? <DashboardArt /> : <SceneArt kind={w.art} />}
                        </div>
                      </div>
                      <h3 className="nx-card__title">{w.title}</h3>
                      <p className="nx-card__desc">{w.desc}</p>
                    </div>
                  </Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== STATS BAND ===== */}
        <section className="nx-section--tight">
          <div className="container">
            <Reveal>
              <div className="nx-band">
                <div className="row g-4 text-center position-relative">
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={8} suffix="+" /></div><div className="nx-band__label">โซลูชันสำเร็จรูป</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={62} suffix="+" /></div><div className="nx-band__label">ลูกค้าองค์กร</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={99.4} decimals={1} suffix="%" /></div><div className="nx-band__label">ความเสถียร</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num">24/7</div><div className="nx-band__label">ดูแลต่อเนื่อง</div></div>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== FEATURED SOLUTIONS (bento) ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <SectionHead
                eyebrow="FEATURED SOLUTIONS"
                title={<>เลือกโซลูชันที่ <span className="nx-gradient-text">เหมาะกับธุรกิจคุณ</span></>}
                subtitle="โซลูชันยอดนิยมที่พร้อมปรับแต่งให้ตรงกับธุรกิจของคุณ"
              />
            </Reveal>
            <Reveal delay={100}>
              <div className="nx-bento mt-4">
                {featured.map((s) => (
                  <SolutionTile key={s.slug} to={`/innovation/${s.slug}`} photo={s.photo} badge={s.badge} title={s.short} tagline={s.tagline} />
                ))}
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== QUOTE ===== */}
        <section className="nx-section--tight nx-bg-surface">
          <div className="container">
            <Reveal>
              <div style={{ maxWidth: 820, margin: "0 auto" }}>
                <Quote {...review} />
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== ALL SOLUTIONS ===== */}
        <section className="nx-section" id="all-solutions">
          <div className="container">
            <Reveal>
              <SectionHead eyebrow="ALL SOLUTIONS" title="โซลูชันทั้งหมด" subtitle={`เลือกดูได้กว่า ${SOLUTIONS.length} ระบบที่พร้อมปรับให้เข้ากับธุรกิจของคุณ`} />
            </Reveal>
            <div className="row g-4 mt-2">
              {SOLUTIONS.map((s, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={s.slug}>
                  <Reveal delay={(i % 4) * 50}>
                    <Link to={`/innovation/${s.slug}`} className="nx-portfolio d-block">
                      <Photo src={s.photo} alt={s.short} fallback="🧩" />
                      <div className="nx-portfolio__body">
                        <span className="nx-portfolio__tag">{s.badge}</span>
                        <h3 className="nx-portfolio__title">{s.short}</h3>
                        <span className="nx-subcard__link">ดูเพิ่มเติม →</span>
                      </div>
                    </Link>
                  </Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== VISION CTA ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <div className="nx-spotlight">
                <div className="row align-items-center g-4 position-relative">
                  <div className="col-12 col-lg-7">
                    <span className="nx-eyebrow">START A PROJECT</span>
                    <h2 className="nx-heading mt-3">Turn your vision into <span className="nx-gradient-text">a shipped product.</span></h2>
                    <p className="nx-card__desc mb-4">เล่าไอเดียหรือปัญหาของคุณให้เราฟัง แล้วเราจะช่วยเปลี่ยนให้เป็นระบบที่ใช้งานได้จริง พร้อมส่งมอบและดูแลต่อเนื่อง</p>
                    <div className="d-flex flex-wrap gap-3">
                      <Btn to="/booking">เริ่มโปรเจกต์</Btn>
                      <Btn to="/booking" variant="ghost">นัดเดโม</Btn>
                    </div>
                  </div>
                  <div className="col-12 col-lg-5">
                    <div className="row g-3 text-center">
                      <div className="col-4"><div className="nx-stat__num"><CountUp end={47} suffix="+" /></div><div className="nx-stat__label">โปรเจกต์</div></div>
                      <div className="col-4"><div className="nx-stat__num">24/7</div><div className="nx-stat__label">ซัพพอร์ต</div></div>
                      <div className="col-4"><div className="nx-stat__num"><CountUp end={4.9} decimals={1} /></div><div className="nx-stat__label">คะแนนรีวิว</div></div>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== TAGLINE ===== */}
        <section className="nx-section--tight nx-bg-soft">
          <div className="container">
            <Reveal>
              <div className="nx-tagline">
                <h2 className="nx-tagline__title">สร้างจากไทย — <span className="nx-gradient-text">ส่งมอบทั่วโลก</span></h2>
                <div className="nx-tagline__card">
                  <span className="nx-eyebrow">เริ่มโปรเจกต์กับเรา</span>
                  <p className="nx-card__desc my-3">คุยฟรี 30 นาที ไม่มีข้อผูกมัด แล้วเราจะช่วยประเมินแนวทางให้</p>
                  <Btn to="/booking" block>พูดคุยกับเรา</Btn>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}
